import React from 'react';
import './components.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col">
          <div className="footer-brand">The Happy Book Stack</div>
          <p className="footer-brand-tag">
            A quiet corner for curious readers — with 35,000 books and a chair always free.
          </p>
          <div className="footer-socials" aria-label="Social links">
            <a
              href="https://www.instagram.com/thehappybookstackutah/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9a5.5 5.5 0 0 1-5.5 5.5h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 1.8A3.7 3.7 0 0 0 3.8 7.5v9a3.7 3.7 0 0 0 3.7 3.7h9a3.7 3.7 0 0 0 3.7-3.7v-9a3.7 3.7 0 0 0-3.7-3.7h-9Zm9.45 1.35a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.8A3.2 3.2 0 1 0 12 15.2 3.2 3.2 0 0 0 12 8.8Z" />
              </svg>
            </a>
            <a href="mailto:thehappybookstackutah@gmail.com" aria-label="Email">✉</a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Visit</h4>
          <p>452 W Center St #105, Pleasant Grove, UT 84062</p>
          <a href="mailto:thehappybookstackutah@gmail.com">thehappybookstackutah@gmail.com</a>
        </div>

        <div className="footer-col">
          <h4>Hours</h4>
          <p>Monday - Thursday · 10 AM - 6 PM</p>
          <p>Friday · 10 AM - 7 PM</p>
          <p>Saturday · 9 AM - 7 PM</p>
          <p>Sunday · Closed</p>
        </div>

        <div className="footer-col">
          <h4>Explore</h4>
          <a href="#about">Story</a>
          <a href="#featured">Staff picks</a>
          <a href="#calendar">Events</a>
          <a href="#trading">Buy · Sell · Trade</a>
          <a href="#visit">Find us</a>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© 2025 The Happy Book Stack Utah</span>
        <span className="mark">452 W Center St #105, Pleasant Grove, UT 84062</span>
      </div>
    </footer>
  );
}

export default Footer;
